// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#error-message {
  max-width: 485px;
  margin: 0 0 0 10px;
  padding: 0;
  line-height: 24px;
  vertical-align: middle;
  display: inline-block;
}

.material-icons {
  vertical-align: middle;
  line-height: 24px;
  color: #FF0019;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/error/error.component.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,sBAAA;EACA,iBAAA;EACA,cAAA;AADJ","sourcesContent":["@import '../../../assets/sass/colors';\n\n#error-message {\n    max-width: 485px;\n    margin: 0 0 0 10px;\n    padding: 0;\n    line-height: 24px;\n    vertical-align: middle;\n    display: inline-block;\n\n}\n.material-icons {\n    vertical-align: middle;\n    line-height: 24px;\n    color: signal-color-palette(100-red);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
